import request from "@/utils/request";
import URL from "@/api/baseUrl";

const basePath = `${URL.vip}/vip-receivable-bill`;

export default class ReconciliationManagement {
  static list(params = {}) {
    return request.get(`${basePath}/list`, params);
  }

  static getInfo(params = {}) {
    return request.get(`${basePath}/getInfo`, params);
  }

  static batchGetInfo(data = {}) {
    return request.post(`${basePath}/batchGetInfo`, data);
  }

  static confirm(data = {}) {
    return request.post(`${basePath}/confirm`, data);
  }

  static batchConfirm(data = {}) {
    return request.post(`${basePath}/batchConfirm`, data);
  }

  static templateExportBillFromFeeDetail(data = {}) {
    return request.post(`${basePath}/templateExportBillFromFeeDetail`, data, {
      responseType: "blob",
    });
  }
}
